<template>
  <div>
    <el-button
      style="margin-bottom: 20px"
      type="primary"
      v-if="hasAuth('sys:discount:add')"
      @click="add(null)"
      >新增
    </el-button>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column align="center" label="商品名" prop="commodityName">
      </el-table-column>
      <el-table-column align="center" label="消费件数区间">
        <template slot-scope="{ row }">
          {{ row.num || 0 }} - {{ row.topNum || 0 }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="单件优惠" prop="discount">
      </el-table-column>

      <el-table-column align="center" fixed="right" label="操作" prop="icon">
        <template slot-scope="scope">
          <el-button
            plain
            type="primary"
            @click="add(scope.row)"
            v-if="hasAuth('sys:discount:edit')"
            >编辑</el-button
          >
          <el-button
            plain
            type="danger"
            @click="delHandle(scope.row.id)"
            v-if="hasAuth('sys:discount:del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :before-close="handleClose"
      :title="editForm.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="商品" prop="commodityId">
          <el-row>
            <el-col :span="18">
              <el-input v-model="editForm.commodityName" disabled></el-input>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                style="height: 40px; width: 100%"
                type="primary"
                @click="selectGoods"
                >选择
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="消费件数区间">
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="editForm.num"
                placeholder="最低消费件数(最低件数为0)"
                type="number"
              ></el-input>
            </el-col>
            <el-col :span="2" style="text-align: center">-</el-col>
            <el-col :span="11">
              <el-input
                v-model="editForm.topNum"
                placeholder="最高消费件数(包含当前件数)"
                type="number"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="单件优惠" prop="discount">
          <el-input
            v-model="editForm.discount"
            placeholder="单件优惠"
            type="number"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <selGoods ref="selGoods" @selectgoods="selectg" />
  </div>
</template>
<script>
import selGoods from "../singProduct/components/selectgoods.vue";

export default {
  name: "discount",
  components: {
    selGoods,
  },
  data() {
    return {
      editForm: {
        discount: null,
        num: null,
        topNum: null,
        commodityId: null,
        commodityName: null,
      },
      tableData: [],
      dialogVisible: false,
      rules: {},
      goodsList: [],
    };
  },
  created() {
    this.getHomePopList();
  },
  methods: {
    selectg(e) {
      console.log(e);
      this.editForm.commodityId = e.id;
      this.editForm.commodityName = e.name;
    },
    selectGoods(e) {
      this.$refs.selGoods.init(e.commodityId);
    },
    add(event) {
      if (event) {
        this.editForm = JSON.parse(JSON.stringify(event));
        this.editForm.discount = this.editForm.discount
          ? this.editForm.discount
          : null;
      }
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
      this.editForm = {
        discount: 0,
        num: null,
        topNum: null,
        commodityId: "",
        commodityName: "",
      };
    },
    getHomePopList() {
      this.$axios.post("/admin/discountGrade/getList", {}).then((res) => {
        this.tableData = res.data;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            num: Number(this.editForm.num),
            discount: Number(this.editForm.discount),
            topNum: Number(this.editForm.topNum),
            commodityId: this.editForm.commodityId,
          };
          if (this.editForm.id) {
            obj.id = this.editForm.id;
            this.$axios.post("/admin/discountGrade/upd", obj).then((res) => {
              this.handleClose();
              this.getHomePopList();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
          } else {
            this.$axios.post("/admin/discountGrade/add", obj).then((res) => {
              this.handleClose();
              this.getHomePopList();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
          }
        } else {
          return false;
        }
      });
    },
    delHandle(event) {
      var _this = this;
      this.$confirm("此操作将删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/admin/discountGrade/del", {
              id: event,
            })
            .then((res) => {
              _this.getHomePopList();
              _this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
